import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c5fda34"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "checkBox__error"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: /*#__PURE__*/_mergeModels({
    disabled: { type: Boolean, default: false },
    onlyRead: { type: Boolean },
    error: {}
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

// eslint-disable-next-line no-undef
const checkboxValue = _useModel<boolean>(__props, "modelValue");

const props = __props;

const changeCheckbox = () => {
  if (!props.onlyRead) {
    checkboxValue.value = !checkboxValue.value;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([[
      {
        active: checkboxValue.value,
      },
      { onlyRead: _ctx.onlyRead },
      {
        error: _ctx.error?.length,
      },
    ], "checkBox"]),
    disabled: _ctx.disabled || _ctx.onlyRead,
    type: "button",
    onClick: _withModifiers(changeCheckbox, ["stop"])
  }, [
    _createVNode(_component_base_icon, {
      class: _normalizeClass([{ active: checkboxValue.value }, "checkBox__check"]),
      color: "#009D3E",
      "font-size": "16",
      name: "done"
    }, null, 8, ["class"]),
    (_ctx.error?.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})